<template>
  <div id="service-page">
    <!-- site-navigation start -->
    <NavbarView />
    <!-- site-navigation end -->

    <!-- header begin -->
    <header class="page-head services-parallax-header">
      <div class="parallax-container">
        <!-- Background Layer -->
        <div class="layer-bg">
          <div class="grid"></div>
        </div>

        <!-- Middle Layer -->
        <div class="layer-mid">
          <div class="service-visual">
            <div class="code-editor">
              <div class="code-line"></div>
              <div class="code-line"></div>
              <div class="code-line"></div>
              <div class="code-line"></div>
            </div>
          </div>

          <div class="service-visual">
            <div class="ai-visual">
              <div class="neural-network" ref="neuralNetwork">
                <!-- Neural network nodes and connections will be generated dynamically -->
              </div>
            </div>
          </div>

          <div class="service-visual">
            <div class="marketing-visual">
              <div class="chart-bar" style="height: 40px; left: 20px"></div>
              <div class="chart-bar" style="height: 60px; left: 50px"></div>
              <div class="chart-bar" style="height: 30px; left: 80px"></div>
              <div class="chart-bar" style="height: 70px; left: 110px"></div>
              <div class="chart-bar" style="height: 50px; left: 140px"></div>
            </div>
          </div>
        </div>

        <!-- Foreground Layer -->
        <div class="layer-fg">
          <div class="service-icon-top">
            <i class="fa fa-code"></i>
            <div class="service-label">Desenvolvimento</div>
          </div>

          <div class="service-icon-top">
            <i class="fa fa-cogs"></i>
            <div class="service-label">Inteligência Artificial</div>
          </div>

          <div class="service-icon-top">
            <i class="fa fa-line-chart"></i>
            <div class="service-label">Marketing Digital</div>
          </div>
        </div>
      </div>

      <!-- Overlay content -->
      <div class="header-wrapper">
        <div class="container">
          <div class="row">
            <div class="col-md-12"></div>
          </div>
        </div>
        <!-- /.container -->
      </div>
      <!-- /.header-wrapper -->
    </header>
    <!-- /.page-head (header end) -->

    <div class="main-content">
      <!--  begin services section -->

      <section class="bg-white">
        <div class="container">
          <div class="headline text-center">
            <div class="row">
              <div class="col-md-6 col-md-offset-3">
                <h2 class="section-title">o que fazemos</h2>
                <p class="section-sub-title">
                  soluções digitais sob medida para o seu negócio
                </p>
                <!-- /.section-sub-title -->
              </div>
            </div>
          </div>
          <!-- /.headline -->

          <div class="service-list">
            <div class="row">
              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-umbrella"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Suporte Técnico Contínuo</h3>
                    <p class="service-description">
                      Suporte e manutenção para sistemas, sites e servidores com
                      atendimento rápido e confiável sempre que você precisar.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-thumbs-up"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Desempenho e Velocidade</h3>
                    <p class="service-description">
                      Entregamos soluções otimizadas com foco em carregamento
                      rápido, responsividade e escalabilidade.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-bug"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Código de Qualidade</h3>
                    <p class="service-description">
                      Nossos projetos seguem boas práticas, com testes
                      automatizados e revisão de código para evitar erros em
                      produção.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-cloud-download"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Sites e Landing Pages</h3>
                    <p class="service-description">
                      Desenvolvemos páginas de vendas, hotsites e sites
                      institucionais com design profissional e foco em
                      conversão.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-tachometer"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Infraestrutura & DevOps</h3>
                    <p class="service-description">
                      Cuidamos de automações, deploys, backups e monitoramento
                      para garantir alta disponibilidade e segurança dos seus
                      sistemas.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-briefcase"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Marketing e Design</h3>
                    <p class="service-description">
                      Oferecemos branding, SEO, anúncios em redes sociais,
                      criação de artes e banners personalizados para sua
                      presença digital.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>
            </div>
            <!--  end of .row  -->
          </div>
          <!--  end of .service-list  -->
        </div>
        <!-- end of .container -->
      </section>
      <!--  end of services section -->
    </div>
    <!--  end of .main-content  -->

    <FooterView />
  </div>
</template>

<script>
import NavbarView from "@/components/Navbar.vue";
import FooterView from "@/components/Footer.vue";

export default {
  name: "ServiceView",
  components: {
    NavbarView,
    FooterView,
  },
  mounted() {
    this.generateNeuralNetwork();
  },
  methods: {
    generateNeuralNetwork() {
      const neuralNetwork = this.$refs.neuralNetwork;
      if (!neuralNetwork) return;

      const nodeCount = 15;
      const nodes = [];

      // Create nodes
      for (let i = 0; i < nodeCount; i++) {
        const node = document.createElement("div");
        node.className = "node";

        // Position nodes in a somewhat structured pattern
        let x, y;

        if (i < 4) {
          // Input layer
          x = 10 + Math.random() * 20;
          y = 10 + i * 25;
        } else if (i < 10) {
          // Hidden layer
          x = 80 + Math.random() * 20;
          y = 5 + (i - 4) * 15;
        } else {
          // Output layer
          x = 150 + Math.random() * 20;
          y = 20 + (i - 10) * 20;
        }

        node.style.left = x + "px";
        node.style.top = y + "px";

        neuralNetwork.appendChild(node);
        nodes.push({ element: node, x, y });
      }

      // Create connections
      for (let i = 0; i < 4; i++) {
        for (let j = 4; j < 10; j++) {
          this.createConnection(nodes[i], nodes[j], neuralNetwork);
        }
      }

      for (let i = 4; i < 10; i++) {
        for (let j = 10; j < nodeCount; j++) {
          this.createConnection(nodes[i], nodes[j], neuralNetwork);
        }
      }
    },
    createConnection(nodeA, nodeB, container) {
      const connection = document.createElement("div");
      connection.className = "connection";

      const dx = nodeB.x - nodeA.x;
      const dy = nodeB.y - nodeA.y;
      const length = Math.sqrt(dx * dx + dy * dy);
      const angle = (Math.atan2(dy, dx) * 180) / Math.PI;

      connection.style.width = length + "px";
      connection.style.height = "1px";
      connection.style.left = nodeA.x + 6 + "px";
      connection.style.top = nodeA.y + 6 + "px";
      connection.style.transform = `rotate(${angle}deg)`;

      container.appendChild(connection);
    },
  },
};
</script>

<style scoped>
/* Services Parallax Header Styles */
.services-parallax-header {
  position: relative;
  overflow: hidden;
  height: 157px;
}

.parallax-container {
  /* position: absolute; */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

/* Background Layer */
.layer-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0a192f 0%, #112240 50%, #233554 100%);
  z-index: 1;
}

.layer-bg .grid {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.05) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 20px 20px;
  animation: gridMove 20s linear infinite;
}

/* Middle Layer */
.layer-mid {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.service-visual {
  width: 200px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.code-editor {
  background: rgba(20, 40, 80, 0.7);
  border-radius: 8px;
  border: 1px solid rgba(100, 255, 255, 0.2);
  box-shadow: 0 0 20px rgba(0, 150, 255, 0.2);
  padding: 10px;
  width: 90%;
  height: 90%;
  position: relative;
}

.code-line {
  height: 8px;
  margin: 6px 0;
  background: rgba(100, 200, 255, 0.3);
  border-radius: 4px;
  animation: codeBlink 2s ease-in-out infinite;
}

.code-line:nth-child(1) {
  width: 80%;
  animation-delay: 0s;
}
.code-line:nth-child(2) {
  width: 60%;
  animation-delay: 0.5s;
}
.code-line:nth-child(3) {
  width: 70%;
  animation-delay: 1s;
}
.code-line:nth-child(4) {
  width: 50%;
  animation-delay: 1.5s;
}

.ai-visual {
  position: relative;
  width: 90%;
  height: 90%;
}

.neural-network {
  position: absolute;
  width: 100%;
  height: 100%;
}

.node {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #64ffda;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(100, 255, 218, 0.8);
  animation: nodePulse 3s ease-in-out infinite;
}

.connection {
  position: absolute;
  background: rgba(100, 255, 218, 0.4);
  transform-origin: left center;
  animation: connectionFlow 4s ease-in-out infinite;
}

.marketing-visual {
  background: rgba(20, 40, 80, 0.7);
  border-radius: 8px;
  border: 1px solid rgba(100, 255, 255, 0.2);
  box-shadow: 0 0 20px rgba(0, 150, 255, 0.2);
  width: 90%;
  height: 90%;
  position: relative;
  overflow: hidden;
}

.chart-bar {
  position: absolute;
  bottom: 10px;
  width: 20px;
  background: linear-gradient(to top, #64ffda, #0a81ab);
  border-radius: 3px 3px 0 0;
  animation: chartGrow 3s ease-in-out infinite;
}

/* Foreground Layer */
.layer-fg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.service-icon-top {
  width: 80px;
  height: 80px;
  background: rgba(10, 25, 47, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 30px rgba(100, 255, 218, 0.5);
  border: 2px solid rgba(100, 255, 218, 0.7);
  color: #64ffda;
  font-size: 32px;
  transition: all 0.3s ease;
  position: relative;
  animation: iconFloat 4s ease-in-out infinite;
}

.service-icon-top:hover {
  transform: scale(1.1);
  box-shadow: 0 0 40px rgba(100, 255, 218, 0.8);
}

.service-label {
  position: absolute;
  bottom: -40px;
  color: white;
  text-align: center;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: 120px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
}

/* Header wrapper overlay */
.header-wrapper {
  position: relative;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 65px 0px;
}

/* Animations */
@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(20px, 20px);
  }
}

@keyframes codeBlink {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}

@keyframes nodePulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}

@keyframes connectionFlow {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.6;
  }
}

@keyframes chartGrow {
  0% {
    transform: scaleY(0.3);
  }
  50% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0.7);
  }
}

@keyframes iconFloat {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  /* Simplify parallax layers for tablet */
  .layer-mid {
    opacity: 0.7;
    gap: 15px;
    justify-content: center;
  }

  .layer-fg {
    justify-content: center;
    gap: 25px;
    padding: 0 20px;
  }

  .service-visual {
    width: 80px;
    height: 50px;
  }

  .service-icon-top {
    width: 55px;
    height: 55px;
    font-size: 22px;
  }

  .service-label {
    font-size: 9px;
    width: 70px;
    bottom: -30px;
  }

  .code-editor,
  .marketing-visual {
    padding: 8px;
  }

  .code-line {
    height: 3px;
    margin: 2px 0;
  }

  .chart-bar {
    width: 10px;
  }

  /* Hide neural network visual on tablet for cleaner look */
  .service-visual:nth-child(2) {
    display: none;
  }

  /* Reduce grid animation intensity */
  .grid {
    opacity: 0.3;
    background-size: 25px 25px;
  }
}

@media (max-width: 480px) {
  /* Ultra-simplified mobile experience */
  .layer-mid {
    display: none; /* Hide all visual complexity on mobile */
  }

  .layer-fg {
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    gap: 15px;
    padding: 20px 10px;
  }

  .service-icon-top {
    width: 45px;
    height: 45px;
    font-size: 18px;
    position: relative;
  }

  .service-label {
    font-size: 7px;
    width: 50px;
    bottom: -25px;
    letter-spacing: 0.5px;
  }

  /* Simplify background grid */
  .grid {
    opacity: 0.2;
    background-size: 30px 30px;
  }

  /* Reduce animations for performance */
  .service-icon-top {
    animation: none;
  }

  /* Static icons on mobile - disable float animation */
  @keyframes iconFloat {
    0%,
    100% {
      transform: translateY(0px);
    }
  }
}
</style>
